import React from 'react';
import JournalComponent from '../components/Journal';

const Journal = () => {
    return (
        <div>
            <JournalComponent />
        </div>
    );
};

export default Journal;
